import axios from '@/services/axios'

export default {
    getmarketoverview(search, source) {
        return axios.get("/brandindex/getmarketoverview", { params: search, cancelToken: source.token });
    },

    getallbyperiod(search, source) {
        return axios.get("/brandindex/getallbyperiod", { params: search, cancelToken: source.token });
    },

    getmajorclasslist(search, source) {
        return axios.get("/brandindex/getmajorclasses", { params: search, cancelToken: source.token });
    },

    getmiddleclasslist(search, source) {
        return axios.get("/brandindex/getmiddleclasses", { params: search, cancelToken: source.token });
    },
};